import { render, staticRenderFns } from "./UserMenuNavbar.vue?vue&type=template&id=d448de9c"
import script from "./UserMenuNavbar.vue?vue&type=script&lang=js"
export * from "./UserMenuNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports